export enum CommandsWithPositionalArguments {
  futureRollbackCount = 'futureRollbackCount',
  futureRollbackFromTag = 'futureRollbackFromTag',
  futureRollbackSQl = 'futureRollbackSQl',
  rollback = 'rollback',
  rollbackCount = 'rollbackCount',
  rollbackCountSQL = 'rollbackCountSQL',
  rollbackDate = 'rollbackDate',
  rollbackSql = 'rollbackSql',
  rollbackToDate = 'rollbackToDate',
  rollbackToDateSQL = 'rollbackToDateSQL',
  rollbackOneChangeset = 'rollbackOneChangeset',
  rollbackOneChangesetSQL = 'rollbackOneChangesetSQL',
  rollbackOneUpdate = 'rollbackOneUpdate',
  rollbackOneUpdateSQL = 'rollbackOneUpdateSQL',
  tag = 'tag',
}
